import { gql } from "@apollo/client";

export const UPDATE_DRAFT_PREVIEW_INTEGRATE = gql`
  mutation UpdateDraftPreviewIntegrate(
    $instagramUsername: String!
    $pixel: String
    $googleAnalytics4: String
    $language: String
  ) {
    updatePreview(
      instagramUsername: $instagramUsername
      pixel: $pixel
      googleAnalytics4: $googleAnalytics4
      language: $language
    ) {
      id
      pixel
      googleAnalytics4
      language
      updatedAt
    }
  }
`;

export interface UpdateDraftPreviewIntegrateData {
  updatePreview: {
    id: string;
    pixel: string | null;
    googleAnalytics4: string | null;
    language: string | null;
    updatedAt: string;
  };
}

export interface UpdateDraftPreviewIntegrateVariables {
  instagramUsername: string;
  pixel?: string | null;
  googleAnalytics4?: string | null;
  language?: string | null;
}
